import type { TFunding, TOrderWithScheduledOrder } from '@dekafvv/sharedfrontend';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialScheduledOrdersState } from './data';
import { type TDeletingOrderAnswers } from './types';

export const scheduledOrdersSlice = createSlice({
    name: 'scheduledOrders',
    initialState: initialScheduledOrdersState,
    reducers: {
        setDeletingOrder: (state, action: PayloadAction<TOrderWithScheduledOrder | null>) => ({
            ...state,
            deletingOrder: action.payload,
        }),
        setDeletingScheduledOrdersAnswers: (state, action: PayloadAction<Partial<TDeletingOrderAnswers>>) => ({
            ...state,
            deletingOrderAnswers: {
                ...state.deletingOrderAnswers,
                ...action.payload,
            },
        }),
        setDeletingFundings: (state, action: PayloadAction<TFunding[]>) => ({
            ...state,
            deletingFundings: action.payload,
        }),
        setInitialScheduledOrdersState: () => initialScheduledOrdersState,
    },
});
